/** Reader accessibility settings, persisted under shared keys so web and
 *  mobile read/write the same preference (see readerPalette.ts for the
 *  established pattern this follows). */

/** 'dyslexic' widens
 *  letter/word/line spacing. Falls back to the system font stack when the
 *  font file is not bundled — see mobile/assets/fonts/README.md and
 *  frontend/public/fonts/README.md for the drop-in paths. */
export type ReadingFont = 'default' | 'dyslexic';

export const READING_FONT_STORAGE_KEY = 'reader-reading-font';

/** Persisted "reduce motion" preference. The effective value each client
 *  renders with is this OR the OS-level reduce-motion setting — see each
 *  client's useReducedMotion() hook. */
export const REDUCE_MOTION_STORAGE_KEY = 'reader-reduce-motion';
